// extracted by mini-css-extract-plugin
export var activeMenu = "br1-j";
export var headerM = "br1-k";
export var lMHeader = "br1-c";
export var lMHeaderClose = "br1-i";
export var lMHeaderContainer = "br1-b";
export var lMHeaderLogo = "br1-d";
export var lMHeaderMenu = "br1-g";
export var lMHeaderRight = "br1-e";
export var lMHeaderRightImg = "br1-f";
export var mHeaderShow = "br1-h";
export var minWidthLimit = "br1-a";